/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 CardHeader — NS/Tractie component overrides.
// All MUI v4 style classes are declared explicitly (no implicit inheritance on MUI defaults).
// Tractie deviations: padding 16 (MUI default — kept), avatar/action margins MUI defaults
// blijven, geen typography overrides (titel/subheader gebruiken Typography theme).

export const MuiCardHeaderLightOverrides = {
  root: {
    display: 'flex' as const,
    alignItems: 'center' as const,
    padding: 16,
    transition: 'none',
  },

  avatar: {
    flex: '0 0 auto',
    marginRight: 16,
  },

  action: {
    flex: '0 0 auto',
    alignSelf: 'flex-start' as const,
    marginTop: -8,
    marginRight: -8,
  },

  content: {
    flex: '1 1 auto',
  },

  // title / subheader leeg — Typography ouder-regel bepaalt color/weight via NS theme.
  title: {},

  subheader: {},
} as const;

// Dark variant — geen mode-specifieke overrides; layout/spacing zijn modes-agnostisch.
export const MuiCardHeaderDarkOverrides = {
  ...MuiCardHeaderLightOverrides,
} as const;
